import { useEffect, useState } from 'react';
export var useCardOffset = function () {
    var _a = useState(0), interval = _a[0], setInterval = _a[1];
    var breakpoints = {
        xs: 0,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        '2xl': 1920,
    };
    var mediaQueries = {
        isMobile: {
            query: "(max-width: ".concat(breakpoints.sm, "px)"),
            interval: 2,
            offsets: [12],
            offsetDefault: -12,
        },
        isTablet: {
            query: "(min-width: ".concat(breakpoints.sm, "px) and (max-width: ").concat(breakpoints.lg, "px)"),
            interval: 3,
            offsets: [-24, 48],
            offsetDefault: 24,
        },
        isDesktop: {
            query: "(min-width: ".concat(breakpoints.lg, "px) and (max-width: ").concat(breakpoints.xl, "px)"),
            interval: 5,
            offsets: [48, -24, 24, 24],
            offsetDefault: -48,
        },
        isLargeDesktop: {
            query: "(min-width: ".concat(breakpoints.xl, "px) and (max-width: ").concat(breakpoints['2xl'], "px)"),
            interval: 7,
            offsets: [48, -48, 24, -24, 24, -32],
            offsetDefault: 32,
        },
        isExtraLargeDesktop: {
            query: "(min-width: ".concat(breakpoints['2xl'], "px)"),
            interval: 9,
            offsets: [48, -48, 24, -24, 24, 24, -32, 32],
            offsetDefault: -32,
        },
    };
    var classes = [
        'max-sm:pl-4 sm:h-[26rem] lg:h-[32rem] lg:col-span-2 lg:justify-start lg:items-end xl:col-span-3 3xl:col-span-4',
        'max-sm:justify-end sm:max-lg:justify-end sm:max-lg:items-end lg:col-span-2 xl:col-span-3 3xl:col-span-4',
        'sm:max-lg:h-[24rem] sm:max-lg:col-span-2 sm:max-lg:justify-center sm:max-lg:items-end sm:max-lg:pb-10 lg:col-span-2 lg:justify-center lg:items-center xl:col-span-3 3xl:col-span-4',
        'lg:col-span-3 lg:max-xl:h-[28rem] lg:max-xl:justify-center lg:max-xl:items-center xl:justify-end xl:pt-6 3xl:justify-center xl:col-span-3 3xl:col-span-4',
        'lg:col-span-3 xl:col-span-4 xl:max-3xl:h-[28rem] xl:max-3xl:justify-center xl:max-3xl:items-end xl:max-3xl:pb-10 3xl:col-span-4 3xl:items-end 3xl:justify-end 3xl:pb-10',
        'xl:col-span-4 xl:max-3xl:-mt-4 3xl:col-span-5 3xl:h-[28rem] 3xl:justify-center 3xl:items-end 3xl:pb-10',
        'xl:col-span-4 xl:max-3xl:items-center xl:max-3xl:pl-4 3xl:col-span-5 3xl:-mt-4',
        '3xl:col-span-5 3xl:items-center 3xl:pl-4',
        '3xl:col-span-5 3xl:pt-6',
    ];
    // To check whether event listener is attached or not
    var isAttached = false;
    //Get current interval
    var handleInterval = function () {
        var currentInterval = Object.values(mediaQueries).reduce(function (acc, curr) { return (window.matchMedia(curr.query).matches ? curr.interval : acc); }, 0);
        setInterval(currentInterval);
    };
    // Get current offset
    var handleOffset = function (index) {
        var currentQuery = Object.values(mediaQueries).find(function (query) { return window.matchMedia(query.query).matches; });
        return currentQuery && (currentQuery.offsets[index % interval] || currentQuery.offsetDefault);
    };
    var handleClasses = function (index) {
        var currentQuery = Object.values(mediaQueries).find(function (query) { return window.matchMedia(query.query).matches; });
        return currentQuery && classes[index % interval];
    };
    useEffect(function () {
        handleInterval();
        window.addEventListener('resize', function () {
            handleInterval();
            isAttached = true;
        });
        return function () {
            if (isAttached) {
                window.removeEventListener('resize', function () {
                    handleInterval();
                });
            }
        };
    }, []);
    return { interval: interval, handleOffset: handleOffset, handleClasses: handleClasses };
};
